import React, { useMemo, useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import type { MailersTemplate } from 'bundles/connect/types';
import { formatDateTime, SHORT_DATE_FORMAT } from '../../../../../helpers/formatters/date_time_formats';
import Paginator from '../../paginator';
import EmptyState from '../../empty_state';
import { mailersTemplateEditUrl } from 'bundles/connect/helpers/prospect_api';

type MailersTemplatesSettingsListProps = {
  callListId: number | null;
  templates: MailersTemplate[];
  onDeleteTemplate: (template: MailersTemplate) => void;
}

const PER_PAGE = 5;
export default function MailersTemplatesSettingsList(
  { callListId, templates, onDeleteTemplate }: MailersTemplatesSettingsListProps
) {
  const [page, setPage] = useState(1);
  const paginatedResults = useMemo(() => {
    return templates.slice((page - 1) * PER_PAGE, page * PER_PAGE);
  }, [templates, page]);

  return (
    <div>
      {templates.length > 0 ? (
        <>
          {paginatedResults.map(template => (
            <div className="d-flex gap-2 border-bottom py-2" key={template.id}>
              <FontAwesomeIcon className="py-1" icon={faEnvelope} size="lg"/>
              <div className="flex-grow-1">
                <div className="fw-bold">
                  {template.title}
                </div>
                <div className="text-muted small">
                  Created {formatDateTime(template.createdAt, SHORT_DATE_FORMAT)}
                </div>
              </div>
              <div className="d-flex gap-2">
                <OverlayTrigger
                  overlay={<Tooltip id={`tooltip-${template.id}`}>Call List required</Tooltip>}
                  placement="top"
                  show={!callListId ? undefined : false}
                >
                  <span>
                    <Button
                      disabled={!callListId}
                      href={callListId ? mailersTemplateEditUrl(callListId, template.id) : undefined}
                      variant="link"
                    >
                      <FontAwesomeIcon icon={faPencil}/>
                      Edit
                    </Button>
                  </span>
                </OverlayTrigger>
                <Button
                  className="text-danger"
                  variant="text-danger"
                  onClick={() => onDeleteTemplate(template)}
                >
                  <FontAwesomeIcon icon={faTrash}/>
                  Delete
                </Button>
              </div>
            </div>
          ))}
          {templates.length > PER_PAGE && (
            <div className="d-flex justify-content-center">
              <Paginator currentPage={page} perPage={PER_PAGE} total={templates.length} onSelect={setPage}/>
            </div>
          )}
        </>
      ) : (
        <EmptyState icon={faEnvelope} title="You don't have any mailer export templates" />
      )}
    </div>
  );
}
